import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { observable, Observable, of } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../../@core/auth/auth.service';
import { PlatformConfig } from '../models/platform-config';

@Injectable({
  providedIn: 'root'
})
export class PlatformConfigService {

  protected basePath = '/';

  constructor(
    protected httpClient: HttpClient,
    private authService: AuthService
  ) {
    this.basePath = environment.PLATFORM_API_URL;
  }


  public getDispatchPhone(): Observable<string> {

    let queryParameters = new HttpParams();

    return this.httpClient.get<string>(`${this.basePath}/api/platformconfig/dispatchphone`,
      {
        params: queryParameters
      }
    );
  }

  public getIsHops(): Observable<boolean> {
    return this.httpClient.get<boolean>(`${this.basePath}/api/platformconfig/isHops`);
  }

  public getOrdersProducts(): Observable<boolean> {
    return this.httpClient.get<boolean>(`${this.basePath}/api/platformconfig/orderUseStoreProducts`);
  }

  /**
   * Whether an order confirmation email should be sent when an order is placed
   * internally (e.g. from the Create Order page). Defaults to false.
   */
  public getSendInternalOrderConfirmationEmail(): Observable<boolean> {
    return this.httpClient.get<boolean>(`${this.basePath}/api/platformconfig/sendInternalOrderConfirmationEmail`);
  }

  public getBulkBinUpload(): Observable<boolean> {

    return of(true);

    return this.httpClient.get<boolean>(`${this.basePath}/api/platformconfig/isHops`);
  }


  public getShowRoomAtReceiving(): Observable<boolean> {
    return this.httpClient.get<boolean>(`${this.basePath}/api/platformconfig/showRoomAtReceiving`);
  }

  public getShowReceivingPrinter(): Observable<boolean> {
    return this.httpClient.get<boolean>(`${this.basePath}/api/platformconfig/showReceivingPrinter`);
  }

  public getShowStoragePlanLookupAtReceiving(): Observable<boolean> {
    return this.httpClient.get<boolean>(`${this.basePath}/api/platformconfig/showStoragePlanLookupAtReceiving`);
  }

  public getRoomTreatmentInterval(): Observable<number> {
    return this.httpClient.get<number>(`${this.basePath}/api/platformconfig/roomTreatmentInterval`);
  }


  public getIsSpanish(): Observable<boolean> {
    return this.httpClient.get<boolean>(`${this.basePath}/api/platformconfig/isSpanish`);
  }

  public getPublicDispatchPhone(tenantShortCode: string): Observable<string> {

    let queryParameters = new HttpParams();

    queryParameters = queryParameters.append('tenantShortCode', tenantShortCode)

    return this.httpClient.get<string>(`${this.basePath}/api/platformconfig/public/dispatchphone`,
      {
        params: queryParameters
      }
    );
  }

  public putDispatchPhone(phone: string): Observable<any> {
    return this.httpClient.put(`${this.basePath}/api/platformconfig/dispatchphone`, { phone });
  }

  public getTimelineReportGrouping(): Observable<any> {
    return this.httpClient.get(`${this.basePath}/api/platformconfig/timelineReportGrouping`);
  }

  public getAllConfigValues(): Observable<PlatformConfig[]> {
    return this.httpClient.get<PlatformConfig[]>(`${this.basePath}/api/platformconfig/`);
  }

  public getPrintReceiptOnSave(): Observable<boolean> {
    return this.httpClient.get<boolean>(`${this.basePath}/api/platformconfig/printReceiptOnSave`);
  }

  public getMaxBinsAllowed(): Observable<number> {
    return this.httpClient.get<number>(`${this.basePath}/api/platformconfig/maxBinsAllowed`);
  }


  public getUseHectares(): Observable<boolean> {
    return this.httpClient.get<boolean>(`${this.basePath}/api/platformconfig/useHectares`);
  }

  /** First day of the work week as a JS Date.getDay() value (0 = Sunday ... 6 = Saturday). */
  public getWorkWeekStartDay(): Observable<number> {
    return this.httpClient.get<number>(`${this.basePath}/api/platformconfig/workWeekStartDay`);
  }

  public getShowVarietyRecheckInterval(): Observable<boolean> {
    return this.httpClient.get<boolean>(`${this.basePath}/api/platformconfig/showVarietyRecheckInterval`);
  }

  //Create Platform Configs
  public createPlatformConfig(payLoad: PlatformConfig): Observable<PlatformConfig> {
    return this.httpClient.post<PlatformConfig>(
      `${this.basePath}/api/platformconfig/createPlatformConfig`, payLoad
    );
  }

  //Update Platform Configs
  public updatePlatformConfig(payLoad: PlatformConfig): Observable<PlatformConfig> {
    return this.httpClient.put<PlatformConfig>(
      `${this.basePath}/api/platformconfig/updatePlatformConfig/${payLoad.id}`, payLoad
    );
  }

  //Delete Platform Configs
  public deletePlatformConfig(id: Number): Observable<PlatformConfig> {
    return this.httpClient.delete<PlatformConfig>(
      `${this.basePath}/api/platformconfig/deletePlatformConfig/${id}`);
  }

}
